export default "__VITE_ASSET__e1dd8e64__"